import { object, string } from "superstruct";

import RouteNavigator from "@mpa/toolbox/navigation/Navigator";
import Route from "@mpa/toolbox/navigation/Route";

import { loggedInNavigator } from "../../navigation/routes";

export const mailingNavigator = loggedInNavigator.addNavigator(
    new RouteNavigator().setPath("/mailing"),
);
export const mailingRoute = mailingNavigator.addRoute(new Route());
export const newMailRoute = mailingNavigator.addRoute(new Route().setPath("/nouveau"));
export const mailRoute = mailingNavigator.addRoute(
    new Route().setPath("/:email", object({ email: string() })),
);
